function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgSbpIcon = function SvgSbpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_8395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.22461L5.16856 10.4196V13.5884L2.25341 18.7732L2.25 5.22461Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4561 8.52987L16.1908 6.86067L21.7878 6.85547L13.4561 11.9383V8.52987Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4392 5.19438L13.4547 12.0724L10.5293 10.2824V0.000976562L13.4392 5.19438Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7864 6.85518L16.1893 6.86038L13.4392 5.19438L10.5293 0.000976562L21.7864 6.85518Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4547 18.801V15.464L10.5293 13.708L10.5309 23.9996L13.4547 18.801Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1841 17.148L5.16836 10.4196L2.25 5.22461L21.776 17.1412L16.1841 17.148Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5308 24.002L13.4541 18.8034L16.1821 17.1494L21.774 17.1426L10.5308 24.002Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25293 18.7731L10.5541 13.7091L7.76329 12.0039L5.16808 13.5883L2.25293 18.7731Z",
    fill: "#984995"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_8395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.000976562)"
  }))));
};
export default SvgSbpIcon;